//		pages/Settings/index.tsx

import { useEffect, useRef, useState } from "react";
import BeamioMeMainScreen from '../../components/Setting/index'

const Settings = ({}) => {
    return (
        
        <BeamioMeMainScreen />
        
    )
};

export default Settings;